<template>
  <div class="editor">
    <v-text-field
      v-if="!readOnly"
      v-model="contentTitle"
      dense
      label="Name of Content"
      hide-details=""
      class="mb-2"
      @change="emitCurrentContent"
    />

    <div v-if="!readOnly" class="menubar">
      <v-toolbar dense short>
        <v-btn
          v-for="button in toolbarButtons"
          :key="button.key"
          small
          icon
          :disabled="button.requiresCanRun && !canRun(button)"
          :color="isButtonActive(button) ? 'blue' : 'black'"
          @click="runToolbarButton(button)"
        >
          <v-icon small>{{ button.icon }}</v-icon>
        </v-btn>
      </v-toolbar>
    </div>

    <v-card color="grey-lighten-1" class="pa-2">
      <div v-if="readOnly" class="title">
        {{ contentTitle }}
      </div>
      <editor-content class="editor__content" :editor="editor" />
    </v-card>
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import {
  WYSIWYG_TOOLBAR_BUTTONS,
  runToolbarButtonAction,
  canRunToolbarButton,
  isToolbarButtonActive,
} from "./wysiwygToolbar";

export default {
  name: "ContentWYSIWYG",
  components: {
    EditorContent,
  },
  props: {
    // Content model to use for WYSIWYG content.
    content: {
      default: null,
      type: Object,
    },
    // Should this text editor only be read-only.
    readOnly: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      contentTitle: "",
      editor: null,
    };
  },
  computed: {
    toolbarButtons: () => WYSIWYG_TOOLBAR_BUTTONS,
  },
  mounted() {
    const { title = "", html = "" } = this.content || {};
    this.contentTitle = title;
    this.editor = new Editor({
      editable: !this.readOnly,
      content: html,
      extensions: [
        StarterKit.configure({
          heading: { levels: [1, 2, 3] },
        }),
        Link.configure({ openOnClick: false }),
        Underline,
      ],
      onCreate: ({ editor }) => {
        this.$emit("OnChangeContent", { title: this.contentTitle, html: editor.getHTML() });
      },
      onUpdate: ({ editor }) => {
        this.$emit("OnChangeContent", { title: this.contentTitle, html: editor.getHTML() });
      },
    });
  },
  beforeDestroy() {
    this.editor?.destroy();
    this.editor = null;
  },
  methods: {
    emitCurrentContent() {
      if (!this.editor) return;
      this.$emit("OnChangeContent", { title: this.contentTitle, html: this.editor.getHTML() });
    },
    runToolbarButton(button) {
      runToolbarButtonAction(this.editor, button);
    },
    canRun(button) {
      return canRunToolbarButton(this.editor, button);
    },
    isButtonActive(button) {
      return isToolbarButtonActive(this.editor, button);
    },
  },
  watch: {
    content: {
      handler(newVal) {
        if (!this.editor) return;
        const { title = "", html = "" } = newVal || {};
        this.contentTitle = title;
        this.editor.commands.setContent(html, false);
      },
    },
    readOnly: {
      handler(newVal) {
        this.editor?.setEditable(!newVal);
      },
    },
  },
};
</script>
